/* Treatment section: Load more.
 *
 * The section renders every matching card. A card waiting on mobile carries
 * `data-lm-m`, one waiting on desktop `data-lm-d`, and a section-scoped media
 * query hides each at its own breakpoint, so the first batch is right on both
 * before this file runs. Mobile steps by a count, desktop by whole rows.
 *
 * A press reveals the next batch for the breakpoint the visitor is on, then
 * clears both marks from every card up to the last one revealed. Keeping the
 * shown cards a clean prefix is what stops a resize leaving a gap: without it
 * a desktop press could show cards 7 to 12 while 5 and 6 still wait on mobile.
 *
 * `data-lm-done-m` / `-d` on the row hides the button at a breakpoint with
 * nothing left to show. The section's `noscript` rule shows everything when
 * this file never runs. Guarded, since each section emits its own <script>.
 */
(function () {
  if (window.__ddjTreatmentsLoadMore) return;
  window.__ddjTreatmentsLoadMore = true;

  var desktop = window.matchMedia('(min-width: 768px)');

  function init(button) {
    if (button.dataset.loadMoreReady === 'true') return;
    button.dataset.loadMoreReady = 'true';

    var section = button.closest('.shopify-section') || document;
    var row = button.closest('[data-load-more]');
    var stepM = parseInt(button.dataset.stepM, 10) || 4;
    var stepD = parseInt(button.dataset.stepD, 10) || stepM;

    button.addEventListener('click', function () {
      var mark = desktop.matches ? 'data-lm-d' : 'data-lm-m';
      var step = desktop.matches ? stepD : stepM;
      var items = section.querySelectorAll('[data-load-more-item]');
      var last = -1;
      var revealed = 0;
      var first = null;

      for (var i = 0; i < items.length; i++) {
        if (items[i].hasAttribute(mark)) {
          if (revealed === step) break;
          if (!first) first = items[i];
          revealed++;
        }
        last = i;
      }

      for (var j = 0; j <= last; j++) {
        items[j].removeAttribute('data-lm-m');
        items[j].removeAttribute('data-lm-d');
      }

      if (row) {
        if (!section.querySelector('[data-lm-m]')) row.setAttribute('data-lm-done-m', '');
        if (!section.querySelector('[data-lm-d]')) row.setAttribute('data-lm-done-d', '');
      }

      /* Focus the first card just revealed, so a keyboard user lands on the
       * new content rather than on a button that may be about to go. A blog
       * card is itself the link; a treatment card holds its links inside. */
      var link = first && (first.matches('a') ? first : first.querySelector('a'));
      if (link) link.focus({ preventScroll: true });
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-load-more-button]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
